const Stack = (props) => {
    return (
        <div className={`${props.direction==="horizontal"?"hstack site-row":"stack site-col"} ${props.className || ""}`}>
            {props.children}
        </div>
    )
}

export default Stack;